
export function removeWords(A, B) {
  const setB = new Set(B); // преобразуем B в Set для быстрого поиска
  return A.filter(word => !setB.has(word));
}
